import Vue from 'vue'

export default function ({$axios}) {
    $axios.onRequest(config => {

        if (
            config.url.includes("Xrm") || 
            config.url.includes("/users/getUserInfo") ||
            config.url.includes("/awards/luckyCodes")
            ) {
            // config.baseURL = "http://appv1.armitajmall.com:3000";
            config.headers["Authorization"] = "wAefQZdCEsfslG8MRM5y7ADKfXQG7VekbcT5uT4eWq1b0UkxeuA3b0jEftvYuFz8";
            // let page = 1;
            // let pageSize = 15;
            // if (config.params["page"]) {
            //     page = config.params["page"];
            //     delete config.params["page"];
            //     config.params["filter[skip]"] = (page - 1) * pageSize;
            // }

            // if (config.params["pageSize"]) {
            //     pageSize = config.params["pageSize"];
            //     delete config.params["pageSize"];
            //     config.params["filter[limit]"] = pageSize;
            // }

            // if (config.params["sort"] === null) {
            //     delete config.params["sort"];
            // }

            // if (config.params["sort"]) {
            //     delete config.params["sort"];
            // }
            
            // console.log(config);
        }

        if (!navigator.onLine)
            Vue.prototype.$toast.show('اتصال به اینترنت برقرار نیست،')

    });

    $axios.onError(error => {
        if (error.response.status === 401) {
            if (store.$auth.state.loggedIn) {
                store.$auth.logout();
            }
            redirect('/login');
        }

        // let errorObject = JSON.parse(JSON.stringify(error));
        // console.log(errorObject);
    });
}
